import { setContent, setTokens } from './sessionSlice';
import { SessionTokensState } from './SessionState';
import getCsrSession from '@spa/lib/auth/getCsrSession';

type ServerTokenSessionSyncAction = ReturnType<typeof setContent> | ReturnType<typeof setTokens>;

const createServerTokenSessionSyncAction = (
  tokens: SessionTokensState
): ServerTokenSessionSyncAction => {
  const serverSession = getCsrSession();

  return serverSession === null
    ? setTokens({ localChange: true, tokens })
    : setContent({ localChange: true, content: serverSession });
};

export default createServerTokenSessionSyncAction;
